// UrlInput.tsx
import React from 'react';
import { Grid, TextField, Button, Icon, GridSize } from '@material-ui/core';

type UrlInputProps = {
    url: string;
    setUrl: (value: string) => void;
    titulo: string;
    size?: boolean | GridSize | undefined;
};

const UrlInput: React.FC<UrlInputProps> = ({ url, setUrl, titulo, size = 2 }) => {
    return (
        <Grid
            item
            xs={size}
        >
            <Grid
                // container
                style={{
                    marginTop: '0.5rem',
                    marginBottom: '0.5rem',
                    border: '1px solid #ccc',
                    padding: '8px',
                    borderRadius: '4px',
                }}
            >
                <Grid item>
                    <TextField
                        fullWidth
                        label={titulo}
                        variant="standard"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                        type="url"
                        InputProps={{
                            readOnly: false,
                        }}
                        InputLabelProps={{ style: { color: '#000' }, shrink: true }}
                    />
                </Grid>
            </Grid>
        </Grid>
    );
};

export default UrlInput;
